import React from 'react';
import ContainerHead from 'src/components/ui/ContainerOverlay/ContainerHead/ContainerHead';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import { Product } from 'src/services/productsNew';
import OverlayNavArrows from 'src/components/layouts/OverlayNavArrows/OverlayNavArrows';

export interface HeadProps {
  product: Product | null;
  edit?: boolean;
  setEdit: (edit: boolean) => void;
  onHandleAction: (a: 'cancel' | 'save' | 'close' | 'confirm' | 'draft') => void;
  hideActions?: boolean;
  disabled?: boolean;
  showConfirm?: boolean;
  showSetToDraft?: boolean;
  canSetToDraft?: boolean;
}

const Head: React.FC<HeadProps> = ({
  product,
  edit,
  setEdit,
  onHandleAction,
  hideActions,
  disabled = false,
  showConfirm = false,
  showSetToDraft = false,
  canSetToDraft = false,
}) => {
  const { t } = useTranslation();
  // const isLocked = !!product?.id;
  return (
    <ContainerHead>
      {!hideActions && (
        <Button
          icon="keyboard-tab-right"
          onClick={() => onHandleAction('close')}
          tone={ButtonToneProps.DESTRUCTIVE_TRANSPARENT}
        />
      )}
      <h3 className="typo-text-16--bold text-full">
        {product?.id
          ? product.name && product.name.length > 30
            ? `${product.name.slice(0, 30)}...`
            : product.name
          : t('general.create_product')}
      </h3>
      <OverlayNavArrows />
      <div className="ml-auto flex gap-16 items-center">
        {!hideActions && (
          <>
            {!edit && (
              <>
                {showConfirm && (
                  <Button
                    onClick={() => onHandleAction('confirm')}
                    title={t('product_inventory.confirm_product')}
                    tone={ButtonToneProps.PRIMARY_BLUE}
                  />
                )}
                {showSetToDraft && (
                  <div className="relative flex items-center group">
                    <Button
                      onClick={() => onHandleAction('draft')}
                      title={t('product_inventory.set_to_draft')}
                      tone={ButtonToneProps.SECONDARY}
                      disabled={!canSetToDraft}
                    />
                    {!canSetToDraft && (
                      <div className="absolute right-0 top-full mt-2 p-3 bg-color-night text-white text-[12px] rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10 whitespace-nowrap">
                        {t('product_inventory.set_to_draft_blocked')}
                      </div>
                    )}
                  </div>
                )}
                <Button onClick={() => setEdit(true)} title={t('general.edit')} tone={ButtonToneProps.PRIMARY_BLUE} />
              </>
            )}
            {edit && (
              <div className="flex items-center gap-x-8">
                <Button
                  onClick={() => onHandleAction('cancel')}
                  title={t('general.cancel')}
                  tone={ButtonToneProps.SECONDARY}
                />
                <div className="relative flex items-center">
                  <Button
                    onClick={() => onHandleAction('save')}
                    title={t('general.save')}
                    tone={ButtonToneProps.PRIMARY_BLUE}
                    disabled={disabled}
                  />
                  {disabled && (
                    <div className="relative flex items-center group">
                      <span className="ml-2 status-warning-full cursor-help text-2xl">⚠️</span>
                      <div className="absolute right-full top-1/2 -translate-y-1/2 ml-2 p-3 bg-color-night text-white text-[12px] rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10 whitespace-nowrap">
                        {t('general.save_info')}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        <Button tone={ButtonToneProps.SECONDARY} icon="close" onClick={() => onHandleAction('close')} />
      </div>
    </ContainerHead>
  );
};

export default Head;
